export const firebaseAPIKey = process.env.REACT_APP_FIREBASE_API_KEY;
export const resourceAPIURL = process.env.REACT_APP_RESOURCE_API_URL;

export const wilmaSSODashboardUrl =
  process.env.REACT_APP_WILMA_SSO_DASHBOARD_URL;
export const wilmaSSOAPIUrl = process.env.REACT_APP_WILMA_SSO_API_URL;
export const wilmaSSOAppId = process.env.REACT_APP_WILMA_SSO_APP;

export const wilmaSAVCustomerId = process.env.REACT_APP_WILMA_SAV_CUSTOMER_ID;

/**
 * Base map for Leaflet maps. Default is OpenFreeMap (https://openfreemap.org): free for commercial use, no key,
 * no limits, vector tiles rendered by MapLibre inside Leaflet. Styles: liberty | bright | positron | dark | fiord.
 *
 * We only ever draw postcode districts on top, so by default the road network, buildings and airports are
 * stripped from the style leaving land, water, boundaries and place names. Set REACT_APP_MAP_SHOW_ROADS=true to
 * render the full style.
 *
 * To use a raster provider instead (e.g. Azure Maps / Geoapify), set REACT_APP_MAP_TILE_URL to a {z}/{x}/{y}
 * template — when set it takes precedence over the vector style. Never point this at tile.openstreetmap.org
 * in production; their usage policy forbids distributed apps and they serve a "418 Access blocked" tile.
 */
export const mapStyleUrl =
  process.env.REACT_APP_MAP_STYLE_URL || "https://tiles.openfreemap.org/styles/positron";
export const mapShowRoads = process.env.REACT_APP_MAP_SHOW_ROADS === "true";
/** OpenMapTiles source-layers removed from the style when mapShowRoads is false. */
export const mapHiddenSourceLayers = [
  "transportation",
  "transportation_name",
  "building",
  "housenumber",
  "poi",
  "aeroway",
  "aerodrome_label",
];
export const mapTileUrl = process.env.REACT_APP_MAP_TILE_URL || "";
export const mapTileAttribution =
  process.env.REACT_APP_MAP_TILE_ATTRIBUTION ||
  '<a href="https://openfreemap.org" target="_blank" rel="noreferrer">OpenFreeMap</a> ' +
    '<a href="https://www.openmaptiles.org/" target="_blank" rel="noreferrer">&copy; OpenMapTiles</a> ' +
    'Data from <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noreferrer">OpenStreetMap</a>';

export const tokenStorageKey = "wilma-app-token";
export const appRegistrationIdStorageKey = "wilma-application-registration";
